/**
 * @file 最寄駅とアクセスの値を同期
 */
'use strict'

/**
 * @classname ObserveChangeForAccess
 * @classdesc 最寄駅とアクセスの値を同期
 */
export default class ObserveChangeForAccess {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-toggle-password')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$formArea = this._$e.closest('.nearest-station-form-area')
		this._$formNearestStation = this._$formArea.find('.nearest-station')
		this._$formTransportation = this._$formArea.find('.transportation-to-nearest-station-id')
		this._$formTime = this._$formArea.find('.time-to-nearest-station')
		this._$targetFormArea = $('#how-access-form-wrapper')
		this._$targetFormNearestStation = this._$targetFormArea.find('.how-access-form' + '.target')
		this._$targetFormTransportation = this._$targetFormArea.find('.how-access-form-how-to' + '.target')
		this._$targetFormTime = this._$targetFormArea.find('.how-access-form-time' + '.target')

		this._$e.on('change', (e) => this.onChange(e))
	}

	/**
	 * onChangeのコールバック
	 *
	 * @memberof ObserveChangeForAccess
	 * @return {undefined}
	 */
	onChange(e) {
		console.log(`${this.constructor.name}.onChange`)
		console.log(this._$formNearestStation.val(), '-', this._$formTransportation.val(), '-', this._$formTime.val())
		console.log(this._$targetFormNearestStation.val(), '-', this._$targetFormTransportation, '-')
		this._$targetFormNearestStation.val(this._$formNearestStation.val())
		this._$targetFormTransportation.val(this._$formTransportation.val())
		this._$targetFormTime.val(this._$formTime.val())
	}
}
